module.exports = __webpack_public_path__ + "assets/img/king-idle.f8b425b7.png";